const DEFAULT_SITE_URL = process.env.REACT_APP_SITE_URL || "https://devzcorner.com";

function upsertMeta(selector, attrs) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => {
      if (k !== "content") tag.setAttribute(k, v);
    });
    document.head.appendChild(tag);
  }
  if (attrs.content !== undefined) tag.setAttribute("content", attrs.content);
}

function upsertCanonical(url) {
  let link = document.head.querySelector("link[rel='canonical']");
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

export function setPageSeo({
  title,
  description,
  path = "/",
  image = "/logoNoCut.svg",
  noindex = false,
}) {
  const url = new URL(path, DEFAULT_SITE_URL).toString();
  const imageUrl = new URL(image, DEFAULT_SITE_URL).toString();

  document.title = title;
  upsertMeta("meta[name='description']", { name: "description", content: description });
  upsertMeta("meta[name='robots']", {
    name: "robots",
    content: noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large",
  });

  upsertMeta("meta[property='og:title']", { property: "og:title", content: title });
  upsertMeta("meta[property='og:description']", { property: "og:description", content: description });
  upsertMeta("meta[property='og:url']", { property: "og:url", content: url });
  upsertMeta("meta[property='og:image']", { property: "og:image", content: imageUrl });
  upsertMeta("meta[property='og:type']", { property: "og:type", content: "website" });

  upsertMeta("meta[name='twitter:title']", { name: "twitter:title", content: title });
  upsertMeta("meta[name='twitter:description']", { name: "twitter:description", content: description });
  upsertMeta("meta[name='twitter:image']", { name: "twitter:image", content: imageUrl });
  upsertMeta("meta[name='twitter:card']", { name: "twitter:card", content: "summary_large_image" });

  upsertCanonical(url);
}

